<template>
    <b-container>
        <b-row>
            <b-col style="min-height: 800px;">
                <vue-jitsi-meet v-if="jitsiOptions"
                                ref="jitsiRef"
                                domain="meet.jit.si"
                                :options="jitsiOptions"
                ></vue-jitsi-meet>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>

    import {JitsiMeet} from '@mycure/vue-jitsi-meet';
    import {mapGetters, mapState} from "vuex";

    export default {
        components: {
            VueJitsiMeet: JitsiMeet
        },
        name: 'jitsi-integration',
        props: {
            id: String
        },
        created() {
        },
        data() {
            return {
                conferenceList: []
            };
        },
        computed: {
            ...mapState("account", ["user"]),
            ...mapGetters("account", ['activeConference']),
            jitsiOptions() {
                if (this.activeConference) {
                    return {
                        roomName: this.activeConference.jitsiRoom,
                        noSSL: false,
                        userInfo: {
                            email: '',
                            displayName: this.user.firstName + " " + this.user.lastName,
                        },
                        configOverwrite: {
                            enableNoisyMicDetection: false,
                            prejoinPageEnabled: false,
                        },
                        interfaceConfigOverwrite: {
                            defaultLanguage: 'en',
                            SHOW_JITSI_WATERMARK: false,
                            SHOW_WATERMARK_FOR_GUESTS: false,
                            SHOW_CHROME_EXTENSION_BANNER: false
                        },
                        onload: this.onIFrameLoad
                    };
                }
                return null;
            },
        },
        methods: {
            onIFrameLoad() {
                // do stuff
            },
        },


    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
